export class ShopSessionUtil {

    static createCountryTotals(localeTotals: any[], allowedCountries: string[]): any[] {
        const countryMap = new Map<string, any>();

        localeTotals.forEach(localeTotal => {
            const country = localeTotal.locale?.split('_')[1];

            if (!countryMap.has(country)) {
                countryMap.set(country, {
                    country: country,
                    sessions: 0,
                    events: 0,
                    associateEnrolls: 0,
                    affiliateEnrolls: 0,
                    pcEnrolls: 0,
                    pcEnrollsWithOrder: 0,
                    cartOrders: 0,
                    updatedCartOrders: 0,
                    pendingOrders: 0,
                    localeTotals: [] // List of localeTotals for this country
                });
            }

            const countryTotal = countryMap.get(country);
            countryTotal.sessions += localeTotal.sessions || 0;
            countryTotal.events += localeTotal.events || 0;
            countryTotal.associateEnrolls += localeTotal.associateEnrolls || 0;
            countryTotal.affiliateEnrolls += localeTotal.affiliateEnrolls || 0;
            countryTotal.pcEnrolls += localeTotal.pcEnrolls || 0;
            countryTotal.pcEnrollsWithOrder += localeTotal.pcEnrollsWithOrder || 0;
            countryTotal.cartOrders += localeTotal.cartOrders || 0;
            countryTotal.updatedCartOrders += localeTotal.updatedCartOrders || 0;
            countryTotal.pendingOrders += localeTotal.pendingOrders || 0;

            countryTotal.localeTotals.push(localeTotal);
        });

        const countries = Array.from(countryMap.values());

        // Split into allowed and other countries
        const allowedList = countries.filter(country => allowedCountries.includes(country.country));
        const otherList = countries.filter(country => !allowedCountries.includes(country.country));

        // Sort each list alphabetically
        allowedList.sort((a, b) => a.country?.localeCompare(b.country) || 0);
        otherList.sort((a, b) => a.country?.localeCompare(b.country) || 0);

        // Combine the lists
        return [...allowedList, ...otherList];

        // return Array.from(countryMap.values()).sort((a, b) => a.country?.localeCompare(b.country));
    }

    static createCountryRealtime(localeRealtimeList: any[]): any[] {
        const countryMap = new Map<string, any>();

        localeRealtimeList.forEach(localeRealtime => {
            const country = localeRealtime.locale?.split('_')[1];

            if (!countryMap.has(country)) {
                countryMap.set(country, {
                    country: country,
                    sessions: 0,
                });
            }

            const countryTotal = countryMap.get(country);
            countryTotal.sessions += localeRealtime.sessionCount || 0;
        });

        return Array.from(countryMap.values()).sort((a, b) => b.sessions - a.sessions);
    }

    private static getMaxValue(totals: any, property: string): number {
        return Math.max(...totals?.map(d => Math.max(d[property] || 1)));
    }

    static getBarStyle(totals: any, value: number, property: string): any {
        if (value == 0) {
            return { 'background-color': 'transparent', width: 0 };
        } else {
            return { width: (value / this.getMaxValue(totals, property) * 100) + '%' };
        }
    }
}
